import { burnPoint } from "@/apis/heziShare";
import { sendPoint } from "@/apis/btBoxActivity";

/**
 * 异步请求队列
 * 用于解决数据上报时无法及时获取客户端传递过来的信息问题，导致上报数据结果为空
 */
export const queue = () => {
  let list = null; // 队列
  let currentIndex = null; // 游标
  // 创建队列
  const create = () => {
    // console.log("🚀 ~ file: create ~ list:", list)
    list = [];
    currentIndex = 0;
  }
  // 控制队列
  const next = (cookie) => {
    currentIndex = currentIndex + 1;
    const endIndex = list.length - 1 ;
    if (currentIndex > endIndex) {
      destroy();
      return;
    }
    run(cookie);
  };
  // 添加请求进队列
  const add = (fn,params) => {
    list.push({fn,params});
    // console.log("🚀 ~ file: add ~ list:", list)
  }
  // 执行队列中的请求
  const run = (cookie) => {
    if (list.length == 0) {
      return
    }
    const currentRequestInfo = list[currentIndex];
    try {
      console.log("补充数据上报", currentRequestInfo.params.event)
      currentRequestInfo.fn({...currentRequestInfo.params,...cookie}).then(res => {
        next(cookie);
      })
    } catch (error) {
      next(cookie);
      console.log("🚀 ~ file: queue.request.js:36", error)
    }
  }
  // 销毁队列
  const destroy = () => {
    list = null;
    currentIndex = null;
  }

  return { create, add, run }
};
